import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

//created common component to handle images when js is disabled
const LazyImageWithNoscript = ({
  effect = 'blur',
  placeholderSrc,
  ...props
}) => {
  return (
    <>
      <LazyLoadImage
        effect={effect}
        placeholderSrc={placeholderSrc}
        {...props}
      />
      <noscript>
        <img {...props} />
      </noscript>
    </>
  );
};

export default LazyImageWithNoscript;
